import styled from 'styled-components';
import {
  Text as TextLayoutComponent,
  Loader as LoaderLayoutComponent,
} from '@playbookux/playbook-web-core';

const Container = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 15px;
  padding: 15px 0;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const Error = styled(TextLayoutComponent)`
  text-align: center;
  color: red;
`;

const Loader = styled(LoaderLayoutComponent)`
`;

export {
  Loader,
  Error,
  Container,
  ButtonContainer,
};
